export default __webpack_public_path__ + "static/media/emoji.e536bf5e.svg";